import { SettingsApiTypes } from "@rshbintech.dboul/http";
import { featureToggleKeys } from "./constants";

export const getChatFeatureSettings = (
  clientSettings?: SettingsApiTypes.ClientSettings | null
) =>
  (clientSettings?.settings?.webchat || []).reduce<Record<string, boolean>>(
    (settings, { key, value }) => {
      if (featureToggleKeys.includes(key)) {
        settings[key] = value === "true";
      }

      return settings;
    },
    {}
  );

export const getCountLabel = (count: number) => {
  if (count > 99) {
    return "99+";
  }

  return count;
};
